export const en = {
  noFile: 'no file (%s files only)',
  browse: 'Browse',
}

export const es = en
